module.exports = __webpack_public_path__ + "static/media/TW-GerardRoss-mobile-411x93@2x-80.98abb2c3.webp";